/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-console */
import SelectorEngine from '../../../utils/dom/selector-engine';
import Manipulator from '../../../utils/dom/manipulator';
import Select from '../../../components/Select';
import Request from '../../../utils/request';
import {addInvalidClasses, validFormElementValue, SELECTOR_ERROR_CLASS} from '../../../utils/validateFormElement';
import ValidationUtils from '../../../utils/validation';

const TIME_OPTIONS = Array.from({ length: 29 }, (_, i) => {
	const total = 8 * 60 + i * 30;
	const h = String(Math.floor(total / 60)).padStart(2, '0');
	const m = String(total % 60).padStart(2, '0');
	return `${h}:${m}`;
});

const DAY_SESSION_TYPES = {
	F2F_SESSION: 'F2F Session',
	REMOTE_SESSION: 'Remote Session',
};

class ManageClass {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.js-manage-class-wrapper');
		if (!this._wrapper) return;

		this._courses = [];
		this._currentClass = {};
		this._currentCourse = {};
		this._venueSearchTimeout = null;
		this._classID = new URLSearchParams(window.location.search).get('classId');
		this._coursesApiUrl = Manipulator.getDataAttribute(this._wrapper, 'courses-api-url');
		this._classDetailsApiUrl = Manipulator.getDataAttribute(this._wrapper, 'class-details-api-url');
		this._searchApprovedVenuesApiUrl = Manipulator.getDataAttribute(this._wrapper, 'search-approved-venues-api-url');
		this._updateClassApiUrl = Manipulator.getDataAttribute(this._wrapper, 'update-class-api-url');
		this._classDetailsPageUrl = Manipulator.getDataAttribute(this._wrapper, 'class-details-page-url');
		this._title = this._wrapper.querySelector('.js-manage-class-title');
		this._formContainer = this._wrapper.querySelector('.js-manage-class-form-container');
		this._formFieldsContainer = this._wrapper.querySelector('.js-manage-class-form-fields-container');
		this._formLoading = this._wrapper.querySelector('.js-manage-class-form-container-loading');
		this._formNoResult = this._wrapper.querySelector('.js-manage-class-form-container-no-result');
		this._reviewContainer = this._wrapper.querySelector('.js-manage-class-review-container');
		this._coursesSelectContainer = this._wrapper.querySelector('.js-manage-class-course-select-container');
		this._coursesSelect = this._wrapper.querySelector('.js-manage-class-course-select');
		this._coursesSelectEl = this._wrapper.querySelector('.js-manage-class-course-select select');
		this._coursesSelectPlaceholderContainer = this._wrapper.querySelector('.js-manage-class-course-select-placeholder-container');
		this._coursesSelectPlaceholderEl = this._wrapper.querySelector('.js-manage-class-course-select-placeholder input');
		this._coursesSelectLoading = this._wrapper.querySelector('.js-manage-class-course-select-loading');
		this._courseDatesContainer = this._wrapper.querySelector('.js-manage-class-course-dates-container');
		this._courseDates = this._wrapper.querySelector('.js-manage-class-course-dates');
		this._venueContainer = this._wrapper.querySelector('.js-manage-class-course__venue-container');
		this._venueInput = this._wrapper.querySelector('.js-manage-class-venue-input');
		this._venueInputEl = this._wrapper.querySelector('.js-manage-class-venue-input input');
		this._venueIdInputEl = this._wrapper.querySelector('.js-manage-class-venue-id');
		this._venueResults = this._wrapper.querySelector('.js-manage-class-venue-results');
		this._venueResultsLoading = this._wrapper.querySelector('.js-manage-class-venue-results-loading');
		this._venueResultsNoResults = this._wrapper.querySelector('.js-manage-class-venue-no-results');
		this._costInputEl = this._wrapper.querySelector('.js-manage-class-cost input');
		this._isOnlineContainer = this._wrapper.querySelector('.js-manage-class-enrolment-deadline-container');
		this._enrolmentDeadlineInputEl = this._wrapper.querySelector('.js-manage-class-enrolment-deadline input');
		this._maxAttendeesContainer = this._wrapper.querySelector('.js-manage-class-course__max-attendees-container');
		this._maxAttendeesSelect = this._wrapper.querySelector('.js-manage-class-max-attendees');
		this._maxAttendeesSelectEl = this._wrapper.querySelector('.js-manage-class-max-attendees select');
		this._courseStatusRadiosEl = this._wrapper.querySelectorAll('.js-manage-class-course-status input[type="radio"]');
		this._onlineBookingsRadiosEl = this._wrapper.querySelectorAll('.js-manage-class-online-bookings input[type="radio"]');
		this._waitingListRadios = this._wrapper.querySelectorAll('.js-manage-class-waiting-list input[type="radio"]');
		this._externalUrlInputEl = this._wrapper.querySelector('.js-manage-class-external-url input');
		this._externalUrlContainer = this._wrapper.querySelector('.js-manage-class-external-url-container');
		this._saveBtn = this._wrapper.querySelector('.js-manage-class-save');
		this._editBtn = this._wrapper.querySelector('.js-manage-class-edit');
		this._publishBtn = this._wrapper.querySelector('.js-manage-class-publish');
		this._publishLoading = this._wrapper.querySelector('.js-manage-class-publish-loading');
		this._publishControlsContainer = this._wrapper.querySelector('.js-manage-class-publish-controls-container');
		this._reviewVenue = this._wrapper.querySelector('.js-manage-class-review-venue');
		this._reviewStartDate = this._wrapper.querySelector('.js-manage-class-review-start-date');
		this._reviewCapacity = this._wrapper.querySelector('.js-manage-class-review-capacity');
		this._reviewPrice = this._wrapper.querySelector('.js-manage-class-review-price');
		this._reviewBookings = this._wrapper.querySelector('.js-manage-class-review-bookings');
		this._reviewStatus = this._wrapper.querySelector('.js-manage-class-review-status');
		this._formRules = {
			course: {input: this._coursesSelectEl, errorMessage: 'Please select a course'},
			venue: {input: this._venueInputEl, errorMessage: 'Please select a venue'},
			cost: {input: this._costInputEl, errorMessage: 'Please enter the cost of the course', patterns: [{regex: /^\d+$/, errorMessage: 'Please enter a valid number'}]},
			externalUrl: {input: this._externalUrlInputEl, errorMessage: 'Please enter a website address'},
			enrolmentDeadline: {input: this._enrolmentDeadlineInputEl, errorMessage: 'Please enter an enrolment deadline', wrapperSelector: '.js-manage-class-enrolment-deadline'},
		};
		this._updateFormUI();
		this._initSaveBtnListener();
		this._initEditBtnListener();
		this._initPublishBtnListener();
		this._initValidation();
		this._initCourseSelectListener();
		this._populateMaxAttendees(20);
		this._initVenueAutocompleteListener();
		this._initOnlineBookingsListener();
		this._initialFetchHandler();
	}

	_initSaveBtnListener() {
		this._saveBtn?.addEventListener('click', () => {
			if (!this._validateForm()) {
				const firstInvalid = this._wrapper.querySelector('.invalid-field, .is-invalid');
				const focusTarget = firstInvalid?.querySelector('.lta-select__selected, input:not([type="hidden"]), textarea') ?? firstInvalid;
				firstInvalid?.scrollIntoView({behavior: 'smooth', block: 'center'});
				setTimeout(() => focusTarget?.focus(), 0);
				return;
			}
			this._populateReview();
			this._formContainer.hidden = true;
			this._reviewContainer.hidden = false;
			window.scrollTo({top: 0, behavior: "instant"});
		});
	}

	_initEditBtnListener() {
		this._editBtn?.addEventListener('click', () => {
			this._formContainer.hidden = false;
			this._reviewContainer.hidden = true;
		});
	}

	_initPublishBtnListener() {
		this._publishBtn?.addEventListener('click', () => {
			this._publish();
		});
	}

	_initCourseSelectListener() {
		if (!this._coursesSelectEl) return;
		this._coursesSelectEl.addEventListener('change', () => {
			this._currentCourse = this._courses.find((c) => c.courseId === this._coursesSelectEl.value) || {};
			this._populateMaxAttendees(this._currentCourse?.maxAttendees || 20);
			this._courseDatesContainer.hidden = true;
			const existingDays = this._currentClass?.days;
			if (existingDays?.length) {
				this._renderCourseDays(existingDays.length, existingDays);
				this._currentClass.days = null;
			} else {
				const totalDays = parseInt(this._currentCourse?.totalDays) || 1;
				this._renderCourseDays(totalDays);
			}
			this._updateFormUI();
		});
	}

	_initOnlineBookingsListener() {
		for (const radio of this._onlineBookingsRadiosEl) {
			radio.addEventListener('change', () => this._updateFormUI());
		}
	}

	_initVenueAutocompleteListener() {
		if (!this._venueInputEl) return;
		this._activeVenueIndex = -1;

		document.addEventListener('click', (e) => {
			if (!this._venueInput.contains(e.target)) this._renderVenueResults([]);
		});

		this._venueInputEl.addEventListener('keydown', (e) => {
			const options = this._venueResults.querySelectorAll('[role="option"]');
			if (!options.length) return;

			if (e.key === 'ArrowDown') {
				e.preventDefault();
				this._activeVenueIndex = Math.min(this._activeVenueIndex + 1, options.length - 1);
				this._setActiveVenueOption(options);
			} else if (e.key === 'ArrowUp') {
				e.preventDefault();
				this._activeVenueIndex = Math.max(this._activeVenueIndex - 1, 0);
				this._setActiveVenueOption(options);
			} else if (e.key === 'Enter' && this._activeVenueIndex >= 0) {
				e.preventDefault();
				options[this._activeVenueIndex].click();
			} else if (e.key === 'Escape') {
				this._renderVenueResults([]);
			}
		});

		this._venueInputEl.addEventListener('input', (e) => {
			clearTimeout(this._venueSearchTimeout);
			const query = e.target.value.trim();
			if (query.length < 3) return;

			if (!query) {
				this._renderVenueResults([]);
				return;
			}

			this._venueSearchTimeout = setTimeout(() => {
				this._fetchVenues(query);
			}, 1000);
		});
	}

	_initValidation() {
		Object.values(this._formRules).forEach((rule) => {
			const event = rule.input?.tagName === 'SELECT' ? 'change' : 'input';
			rule.input?.addEventListener(event, () => this._validateField(rule));
		});
	}

	_validateForm() {
		const rulesValid = Object.values(this._formRules).map((rule) => this._validateField(rule)).every(Boolean);
		const datesValid = this._validateDayDates();
		return rulesValid && datesValid;
	}

	_validateDayDates() {
		const dateInputs = this._courseDates?.querySelectorAll('input[type="date"]') || [];
		let valid = true;
		for (const input of dateInputs) {
			if (!input.value) {
				input.classList.add('invalid-field');
				valid = false;
			} else {
				input.classList.remove('invalid-field');
			}
		}
		return valid;
	}

	_validateField = (rule) => {
		const { input, patterns, wrapperSelector, ...opts } = rule;
		if (input?.closest('[hidden]')) return true;
		const value = input?.value?.trim();
		const element = input?.closest(wrapperSelector || ValidationUtils.getFieldWrapper(input?.type));
		if (!validFormElementValue(value, { element, ...opts })) return false;
		if (patterns) {
			for (const { regex, errorMessage } of patterns) {
				if (!regex.test(value)) {
					addInvalidClasses(element);
					const errorEl = element?.querySelector(SELECTOR_ERROR_CLASS);
					if (errorEl) errorEl.innerHTML = errorMessage || opts.errorMessage;
					return false;
				}
			}
		}
		return true;
	};

	_updateFormUI() {
		if (!this._wrapper) return;
		const onlineBookings = [...this._onlineBookingsRadiosEl].find((r) => r.checked);
		const isOnline = onlineBookings?.value === 'Yes';
		const isOnlineTest = this._currentCourse?.format === 'OnlineTest';
		if (this._classID) {
			this._title.innerText = 'Edit Course';
			if (this._coursesSelectContainer) this._coursesSelectContainer.hidden = true;
			if (this._coursesSelectPlaceholderContainer) this._coursesSelectPlaceholderContainer.hidden = false;
		}
		if (this._venueContainer) this._venueContainer.hidden = isOnlineTest;
		if (this._maxAttendeesContainer) this._maxAttendeesContainer.hidden = isOnlineTest;
		if (this._isOnlineContainer) this._isOnlineContainer.hidden = !isOnline;
		if (this._externalUrlContainer) this._externalUrlContainer.hidden = isOnline;
	}

	_populateReview() {
		// Venue
		this._reviewVenue.textContent = this._venueInputEl?.value || '';

		// Start date (first day) & end date (last day)
		const dayRows = this._courseDates?.querySelectorAll('.js-manage-class-day-row') || [];
		const formatDate = (v) => v ? v.split('-').reverse().join('/') : '';
		const startDate = formatDate(dayRows[0]?.querySelector('input[type="date"]')?.value);
		const endDate = dayRows.length > 1 ? formatDate(dayRows[dayRows.length - 1]?.querySelector('input[type="date"]')?.value) : '';
		this._reviewStartDate.textContent = endDate ? `${startDate} - ${endDate}` : startDate;

		// Capacity
		this._reviewCapacity.textContent = this._maxAttendeesSelectEl?.value || '';

		// Price
		const cost = this._costInputEl?.value || '';
		this._reviewPrice.textContent = cost === '0' || cost === '' ? 'Free' : `£${cost}`;

		// Bookings
		const onlineBookings = [...this._onlineBookingsRadiosEl].find((r) => r.checked)?.value;
		this._reviewBookings.textContent = onlineBookings === 'Yes' ? 'Online via LTA' : 'External';

		// Status
		const status = [...this._courseStatusRadiosEl].find((r) => r.checked)?.value || '';
		this._reviewStatus.textContent = status.replace(/([A-Z])/g, ' $1').trim();
	}

	_renderCourseDays(count, days = []) {
		if (!this._courseDates || !this._courseDatesContainer) return;
		this._courseDates.innerHTML = '';
		if (count) this._courseDatesContainer.hidden = false;
		const isQualifications = this._currentCourse?.format === 'Qualifications';

		for (let i = 0; i < count; i++) {
			this._courseDates.append(this._renderDayRow(i, days[i], isQualifications));
		}
	}

	_renderDayRow(index, dayData = {}, isQualifications = true) {
		const dayNum = index + 1;
		const today = new Date().toISOString().split('T')[0];
		const dateValue = dayData.startDateTime?.slice(0, 10) || '';
		const startTime = dayData.startDateTime?.slice(11, 16) || '09:00';
		const endTime = dayData.finishDateTime?.slice(11, 16) || '17:00';
		const sessionType = dayData.sessionType || DAY_SESSION_TYPES.F2F_SESSION;
		const disabled = !isQualifications ? 'disabled' : '';

		const timeOptionsHTML = (selected) => TIME_OPTIONS.map((t) =>
			`<option value="${t}"${t === selected ? ' selected' : ''}>${t}</option>`
		).join('');

		const row = document.createElement('div');
		row.className = 'p-manage-class__dates-row u-border u-rounded js-manage-class-day-row';
		row.dataset.day = dayNum;
		row.setAttribute('role', 'group');
		row.setAttribute('aria-label', `Day ${dayNum}`);

		row.innerHTML = `
			<div class="p-manage-class__dates-day">
				<span class="u-title3">Day ${dayNum}</span>
				<fieldset class="p-manage-class__dates-session-type" role="radiogroup" aria-label="Session type for day ${dayNum}">
					<label>
						<input type="radio" name="sessionType_${index}" value="${DAY_SESSION_TYPES.F2F_SESSION}" ${sessionType.toLowerCase() === DAY_SESSION_TYPES.F2F_SESSION.toLowerCase() ? 'checked' : ''} ${disabled} class="lta-form-check-input" aria-label="Face To Face session for day ${dayNum}" />
						Face To Face
					</label>
					<label>
						<input type="radio" name="sessionType_${index}" value="${DAY_SESSION_TYPES.REMOTE_SESSION}" ${sessionType.toLowerCase() === DAY_SESSION_TYPES.REMOTE_SESSION.toLowerCase() ? 'checked' : ''} ${disabled} class="lta-form-check-input" aria-label="Remote session for day ${dayNum}" />
						Remote
					</label>
				</fieldset>
			</div>
			<div class="p-manage-class__dates-date">
				<label for="classDate_${index}">Date</label>
				<input type="date" id="classDate_${index}" class="p-manage-class__day-input" min="${today}" value="${dateValue}" aria-required="true" aria-label="Date for day ${dayNum}" />
			</div>
			<div class="p-manage-class__dates-start-time">
				<label for="classStartTime_${index}">Start Time</label>
				<select id="classStartTime_${index}" class="p-manage-class__day-input" aria-label="Start time for day ${dayNum}">${timeOptionsHTML(startTime)}</select>
			</div>
			<div class="p-manage-class__dates-end-time">
				<label for="classEndTime_${index}">End Time</label>
				<select id="classEndTime_${index}" class="p-manage-class__day-input" aria-label="End time for day ${dayNum}">${timeOptionsHTML(endTime)}</select>
			</div>
		`;

		const dateInput = row.querySelector(`#classDate_${index}`);
		dateInput.addEventListener('input', () => dateInput.classList.toggle('invalid-field', !dateInput.value));
		if (index === 0) dateInput.addEventListener('input', () => this._syncEnrolmentDeadline(dateInput.value));

		return row;
	}

	_syncEnrolmentDeadline(day1Value) {
		if (!this._enrolmentDeadlineInputEl) return;
		if (!day1Value) {
			this._enrolmentDeadlineInputEl.value = '';
			this._enrolmentDeadlineInputEl.removeAttribute('max');
			return;
		}
		const d = new Date(day1Value);
		d.setDate(d.getDate() - 1);
		const dayBefore = d.toISOString().split('T')[0];
		this._enrolmentDeadlineInputEl.value = dayBefore;
		this._enrolmentDeadlineInputEl.max = dayBefore;
		this._enrolmentDeadlineInputEl.min = dayBefore;
	}

	_populateCourseSelect() {
		const selectWrapper = this._coursesSelect.querySelector('.js-lta-select');
		if (!selectWrapper) return;

		const nativeSelect = SelectorEngine.findOne('select', selectWrapper);
		if (!nativeSelect) return;

		for (const course of this._courses) {
			const option = document.createElement('option');
			option.value = course.courseId;
			option.textContent = course.name;
			nativeSelect.append(option);
		}

		const selectInstance = Select.getInstance(selectWrapper);
		selectInstance.clearItems();
		selectInstance.generateItems();
	}

	_populateMaxAttendees(max) {
		const selectWrapper = this._maxAttendeesSelect?.querySelector('.js-lta-select');
		if (!selectWrapper) return;
		const nativeSelect = SelectorEngine.findOne('select', selectWrapper);
		if (!nativeSelect) return;
		nativeSelect.innerHTML = '';
		for (let i = 1; i <= max; i++) {
			const option = document.createElement('option');
			option.value = String(i);
			option.dataset.ssId = String(i);
			option.textContent = String(i);
			if (i === max) option.setAttribute('selected', '');
			nativeSelect.append(option);
		}
		const selectInstance = Select.getInstance(selectWrapper);
		selectInstance.clearItems();
		selectInstance.generateItems();
	}

	_setActiveVenueOption(options) {
		for (const opt of options) opt.classList.remove('is-active');
		const active = options[this._activeVenueIndex];
		active.classList.add('is-active');
		active.scrollIntoView({ block: 'nearest' });
		this._venueInputEl.setAttribute('aria-activedescendant', active.id);
	}

	_renderVenueResults(venues) {
		this._venueResults.innerHTML = '';
		const isVenuesItems = venues.length > 0;
		this._venueResults.hidden = !isVenuesItems;
		if (this._venueInputEl) {
			this._venueInputEl.setAttribute('aria-expanded', String(isVenuesItems));
			if (!isVenuesItems) this._venueInputEl.removeAttribute('aria-activedescendant');
		}

		if (!isVenuesItems) return;

		this._activeVenueIndex = -1;

		for (const [i, venue] of venues.entries()) {
			const li = document.createElement('li');
			li.id = `venue-option-${i}`;
			li.className = 'p-manage-class__venue-result-item';
			li.setAttribute('role', 'option');
			li.innerHTML = `
				<span class="p-manage-class__venue-name">${venue.name}</span>
				<span class="p-manage-class__venue-registered u-h6" style='white-space: nowrap;'>${venue.isRegistered ? 'LTA Registered' : 'Not LTA Registered'}</span>
			`;
			li.addEventListener('click', () => {
				this._venueInputEl.value = venue.name;
				if (this._venueIdInputEl) this._venueIdInputEl.value = venue.id || '';
				this._renderVenueResults([]);
			});
			this._venueResults.append(li);
		}
	}

	_populateForm() {
		// Populate course
		const courseName = this._courses.find((c) => c.courseId === this._currentClass.courseId)?.name || '';
		if (this._coursesSelectPlaceholderEl) this._coursesSelectPlaceholderEl.value = courseName;
		// Trigger course change to render course days
		if (this._coursesSelectEl) {
			this._coursesSelect?.querySelector(`.lta-select__item[data-ss-id="${this._currentClass.courseId}"]`)?.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
		}
		// Populate Venue
		if (this._venueInputEl) this._venueInputEl.value = this._currentClass.venueName || '';
		if (this._venueIdInputEl) this._venueIdInputEl.value = this._currentClass.venueId || '';
		// Populate Cost
		if (this._costInputEl) this._costInputEl.value = this._currentClass.cost;
		// Populate Online Bookings
		if (this._currentClass.onlineEnabled) {
			this._wrapper.querySelector('.js-manage-class-online-bookings input[value="Yes"]')?.click();
		} else {
			this._wrapper.querySelector('.js-manage-class-online-bookings input[value="No"]')?.click();
		}
		// Populate Enrolment Deadline
		if (this._enrolmentDeadlineInputEl && this._currentClass.enrolmentDeadline) {
			const dateValue = this._currentClass.enrolmentDeadline.slice(0, 10) || '';
			this._enrolmentDeadlineInputEl.value = dateValue;
			this._enrolmentDeadlineInputEl.max = dateValue;
			this._enrolmentDeadlineInputEl.min = dateValue;
		}
		// Populate Waiting List
		if (this._currentClass.waitlistEnabled) {
			this._wrapper.querySelector('.js-manage-class-waiting-list input[value="Yes"]')?.click();
		} else {
			this._wrapper.querySelector('.js-manage-class-waiting-list input[value="No"]')?.click();
		}
		// Populate Max Attendees
		this._maxAttendeesSelect?.querySelector(`.lta-select__item[data-ss-id="${this._currentClass.maximumAttendees}"]`)?.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
		// External url
		if (this._externalUrlInputEl) this._externalUrlInputEl.value = this._currentClass.externalUrl;
		// Populate Status
		if (this._currentClass.status === 'AcceptingBookings') {
			this._wrapper.querySelector('.js-manage-class-course-status input[value="AcceptingBookings"]')?.click();
		} else {
			this._wrapper.querySelector('.js-manage-class-course-status input[value="Hidden"]')?.click();
		}
	}

	_publishPayload() {
		const dayRows = this._courseDates?.querySelectorAll('.js-manage-class-day-row') || [];
		const days = [...dayRows].map((row) => {
			const date = row.querySelector('input[type="date"]').value;
			const startTime = row.querySelector('[id^="classStartTime_"]').value;
			const endTime = row.querySelector('[id^="classEndTime_"]').value;
			return {
				startDateTime: `${date}T${startTime}:00`,
				finishDateTime: `${date}T${endTime}:00`,
				sessionType: row.querySelector('input[type="radio"]:checked')?.value,
			};
		});
		const onlineBookingsEnabled = [...this._onlineBookingsRadiosEl].find((r) => r.checked)?.value === 'Yes';
		const isOnlineTest = this._currentCourse?.format === 'OnlineTest';
		return {
			classId: this._classID || null,
			courseId: this._currentCourse?.courseId || null,
			courseName: this._currentCourse?.name || null,
			venueId: isOnlineTest ? null : (this._venueIdInputEl?.value || null),
			cost: Number(this._costInputEl?.value) || 0,
			maximumAttendees: onlineBookingsEnabled ? (Number(this._maxAttendeesSelectEl?.value) || 0) : null,
			onlineBookingsEnabled,
			waitingListEnabled: onlineBookingsEnabled ? [...this._waitingListRadios].find((r) => r.checked)?.value === 'Yes' : null,
			enrolmentDeadline: onlineBookingsEnabled ? (this._enrolmentDeadlineInputEl?.value || null) : null,
			externalUrl: onlineBookingsEnabled ? null : (this._externalUrlInputEl?.value || null),
			comments: this._currentClass.comments || null,
			status: [...this._courseStatusRadiosEl].find((r) => r.checked)?.value || null,
			days,
		};
	}

	async _publish() {
		try {
			this._publishLoading.hidden = false;
			this._publishControlsContainer.hidden = true;
			const response = await Request.post(this._updateClassApiUrl, this._publishPayload());
			if (response?.classId) {
				window.location.href = `${this._classDetailsPageUrl}?classId=${response.classId}`;
			}
		} catch (e) {} finally {
			this._publishLoading.hidden = true;
			this._publishControlsContainer.hidden = false;
		}
	}

	async _initialFetchHandler() {
		if (this._classID) {
			await this._fetchClassDetails()
			await this._fetchCourses();
			this._populateForm();
		} else {
			await this._fetchCourses();
		}
	}

	async _fetchVenues(query) {
		this._venueResultsLoading.hidden = false;
		this._venueResultsNoResults.hidden = true;
		this._venueResults.hidden = true;
		this._venueResultsLoading.textContent = 'Searching...';

		try {
			const response = await Request.get(`${this._searchApprovedVenuesApiUrl}/?q=${encodeURIComponent(query)}`, {});
			const venues = response.responseContainerContents || [];
			this._renderVenueResults(venues);
			if (!venues.length) this._venueResultsNoResults.hidden = false;
		} catch (error) {
			this._venueResultsNoResults.hidden = false;
			this._renderVenueResults([]);
		} finally {
			this._venueResultsLoading.hidden = true;
		}
	}

	async _fetchCourses() {
		try {
			this._coursesSelectLoading.innerText = 'Loading courses...';
			this._coursesSelectLoading.hidden = false;
			const response = await Request.get(this._coursesApiUrl, {});
			const { courses } = response.responseContainerContents;
			this._courses = courses || [];
			this._populateCourseSelect();
		} catch (error) {
			this._courses = [];
		} finally {
			this._coursesSelectLoading.hidden = true;
		}
	}

	async _fetchClassDetails() {
		try {
			this._formLoading.hidden = false;
			this._formNoResult.hidden = true;
			const response = await Request.get(this._classDetailsApiUrl, { classId: this._classID });
			this._currentClass = response?.responseContainerContents?.class || {};
			if (this._currentClass?.status) this._currentClass.status = this._currentClass.status.replace(/ /g, '');
		} catch (error) {
			this._currentClass = {};
		} finally {
			this._formLoading.hidden = true;
			const hasData = Object.keys(this._currentClass).length > 0;
			this._formNoResult.hidden = hasData;
			this._formFieldsContainer.hidden = !hasData;
		}
	}
}

const globalManageClass = new ManageClass();
export default globalManageClass;
